import { render, staticRenderFns } from "./RabbeyTable3.vue?vue&type=template&id=4fde7184&scoped=true&"
import script from "./RabbeyTable3.vue?vue&type=script&lang=js&"
export * from "./RabbeyTable3.vue?vue&type=script&lang=js&"
import style0 from "./RabbeyTable3.vue?vue&type=style&index=0&id=4fde7184&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fde7184",
  null
  
)

export default component.exports